import { Observable } from "rxjs";
import { IBranchModel } from "./../models/branch.model";
import { IBranchExchangeModel } from "./../models/branch-exchange.model";

export abstract class BranchRepository {
  abstract getBranchById(id_branche: number): Observable<IBranchModel>;
  abstract getBranches(): Observable<IBranchModel[]>;
  abstract getBranchesExchange(id_branche: number): Observable<IBranchExchangeModel>;
}
